import get from 'lodash/get';

// Constants
import { PUBLIC_URL } from '../constants/app'


export function getCustomers(payment) {
  let
    invoices = get(payment, 'invoices'),
    customers = null;

  function getName(obj) {
    let name = get(obj, 'customer.name');
    let legal_name = get(obj, 'customer.legal_name');
    let tax_profile = get(obj, 'customer.tax_profile');

    if (!name) name = legal_name;
    if (!name) name = tax_profile;

    return name;

  } // Get name

  if (Array.isArray(invoices)) {

    if (invoices.length === 0) customers = `Pago sin factura`
    else if (invoices.length === 1) customers = getName(invoices[0]);
    else if (invoices.length > 1) customers = getName(invoices[0]);
    //else if (invoices.length > 1) customers = `${getName(invoices[0])} (${invoices.length} facturas)`;

  } // END if

  return customers ? customers : `Sin datos`;

} // END getCustomers



export function getCurrentEnv(){
  const { href } = window.location;
  let retVal = false;

  if (href.indexOf('localhost') !== -1)                       return retVal = 'local';
  if (href.indexOf('https://app7.porcobrar.com') !== -1)       return retVal = 'production';
  if (href.indexOf('https://dev.app.porcobrar.com') !== -1)   return retVal = 'development';
  if (href.indexOf('https://stage.app.porcobrar.com') !== -1) return retVal = 'staging';

  return retVal;

} // END getCurrentEnv



export function isPublicRoute(){
  const publicRoutes = [`/portal/`, '/checkout/'];
  let retVal = publicRoutes.some(value => window.location.href.indexOf(`${PUBLIC_URL}${value}`) !== -1);
  return retVal;

} // END isPublicRoute

export function pricingRoute(pathname = '') {
  if(pathname.includes('app')) return 'app';
  if(pathname.includes('pricing')) return 'pricing';

} // END pricingRoute

export function getInitials(name) {
  if (!name) return '??';
  const words = name.trim().split(' ');
  if (words.length === 1) {
    return words[0].substring(0, 2).toUpperCase();
  }
  return (words[0][0] + words[1][0]).toUpperCase();
} 

export function formatDateES(dateString, includeTime = true) {
  const date = dateString ? new Date(dateString) : new Date();

  if (isNaN(date.getTime())) return 'N/A';

  const options = {
    year: 'numeric',
    month: 'short',
    day: 'numeric',
    ...(includeTime && { hour: '2-digit', minute: '2-digit' })
  };

  return date.toLocaleDateString('es-MX', options);
}

export const getAllInvoiceItems = (items) => {
  if (!Array.isArray(items) || items.length === 0) return "";
  return items.map(item => item.description).join(" | ");
}

export const buildReconciliationBody = (transaction, invoices) => {
  if (!transaction || !Array.isArray(invoices) || invoices.length === 0) {
    return null;
  }

  return {
    transaction_uuid: transaction.uuid,
    customer_uuid: get(invoices[0], 'customer.uuid'),
    invoices: invoices.map(invoice => ({
      uuid: invoice.uuid,
      amount: Number(invoice.amountToApply || 0),
      currency: invoice.currency || 'MXN',
      currency_rate: Number(invoice.currency_rate || 1)
    }))
  };
}



// WEBPACK FOOTER //
// ./src/libs/helpers.js